import React, { useEffect, useState } from 'react';
import "./style.sass";
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { Error500 } from 'components/Error/Error500';
import { useHistory } from 'react-router-dom';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';

export function PantallaError500() {

    const history = useHistory();

    const handleIrHome = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}`);
    };

    return (
        <>
            <Error500 />
            <div className="boxBtnSolicitar">
                <button className="btnSolicitar" onClick={handleIrHome}>Volver al inicio</button>
            </div>
        </>
    )
}